import { useEffect, useState } from "react";
import "./App.css";
import Workspace from "./components/Workspace";
import userSettings from "./utils/UserSettings";
// import ThemeTest from "./components/ThemeTest";

function App() {
  // 添加状态以确保在设置变化时重新渲染
  const [, setEffectiveTheme] = useState(userSettings.getEffectiveTheme());

  // 监听设置变化
  useEffect(() => {
    const removeListener = userSettings.addListener(() => {
      setEffectiveTheme(userSettings.getEffectiveTheme());
    });

    return () => removeListener();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        backgroundColor: "var(--bg-app)",
        overflow: "hidden",
      }}
    >
      {/* <ThemeTest /> */}
      <Workspace />
    </div>
  );
}

export default App;
